import { useContext } from "react"
import { SeloPremiadoFornecedorContext } from "./SeloPremiadoFornecedorContext"

export function useSeloPremiadoFornecedorContext() {
    return useContext(SeloPremiadoFornecedorContext)
}
